<template>
  <div class="flex-wrapper-app">
    <Navbar />
    <main class="reschedule-form">
      <Loader v-if="isLoading" />

      <div v-else>
        <reschedule-form :errorMessage="errorMessage" :data="formData" :reschedule="reschedule" />
      </div>
    </main>
    <Footer class="footer" />
  </div>
</template>

<script>
import Navbar from '../pages-sections/Navbar.vue';
import RescheduleForm from './Reschedule/RescheduleForm.vue';
import Loader from '../loader/Loader.vue';
import axios from 'axios';
import Footer from '../pages-sections/Footer.vue';

export default {
  name: 'ReschedulePage',
  components: {
    Navbar,
    RescheduleForm,
    Loader,
    Footer,
  },
  data() {
    return {
      formData: {
        nextAvailableRoute: '',
        changedDate: '',
        availableDates: [],
        changedTime: '',
        address: '',
        newAddress: '',
        extraNotes: '',
        choiceToPickup: '',
        defaultAddress: '',
        forceNewAddress: false,
        suggestLocker: false,
        nearbyLockers: [],
        selectedLocker: null,
        addresses: [],
        isInActiveRoute: false,
        skipOnGoingDelivery: '',
        SLMAppLink: false,
        isReturn: false,
        addressId: null,
        defaultAddressId: null,
        countryCode: null,
        isCompleted: false,
        newAddressObject: null,
        pinPlacedByUser: false,
      },
      voucher: '',
      isLoading: true,
      errorMessage: null,
      isCargo: false,
      queryParams: {},
    };
  },
  mounted() {
    this.voucher = this.$route.params?.voucher;
    this.queryParams = this.$route.query;
    this.getDetails();
  },
  methods: {
    async getDetails() {
      const params = {};
      if (this.queryParams.l) {
        params.l = this.queryParams.l;
      }

      await axios
        .get(`${process.env.VUE_APP_COURIER_API}/user/rescheduleDetails/${this.voucher}`, {
          params: params,
        })
        .then(r => {
          if (r?.data.isCompleted) {
            this.errorMessage = 'isCompleted';
            this.formData.isCompleted = true;
          } else {
            this.formData.suggestLocker = r?.data.context.suggestLocker;
            this.formData.address = r?.data.context.defaultAddress;
            this.formData.defaultAddress = r?.data.context.defaultAddress;
            this.formData.defaultAddressId = r?.data.context.defaultAddressId ?? null;
            this.formData.forceNewAddress = !r?.data.context.forceNewAddress
              ? false
              : r?.data.context.forceNewAddress;
            this.formData.nearbyLockers = r?.data.context.nearbyLockers;
            this.formData.addresses = r?.data.context.addresses;
            this.formData.availableDates = r?.data.context.availableDates;
            this.formData.isInActiveRoute = r?.data.context.isInActiveRoute;
            this.formData.isReturn = r?.data.context.isReturn;
            this.formData.forceLockerSelection = r?.data.context.forceLockerSelection;
          }
          this.countryCode = r?.data.context.countryCode;
          this.isLoading = false;
          if (this.countryCode === 'CY' && process.env.VUE_APP_COUNTRY_CODE === 'GR') {
            window.location.href = `${process.env.VUE_APP_BASE_URL_CY}/reschedule/${this.voucher}`;
          }
          if (this.formData.forceLockerSelection) {
            this.formData.choiceToPickup = 'locker';
          }
        })
        .catch(err => {
          const errorMsg = err.response?.data?.error_description;
          this.errorMessage = errorMsg;

          // Check for specific cargo error and redirect
          if (errorMsg === this.$t('reschedulePage.orderIsCargo')) {
            this.$router.push(`/cargo/${err.response?.data?.error_cargo_voucher}`);
          }
          this.isLoading = false;
        });
    },
    async reschedule(data) {
      let context = {
        voucherID: this.voucher,
        changedTime: data.changedTime,
        changedDate: data.changedDate,
        newNote: data.extraNotes,
        'sys-channel': 'tracking-page',
        skipOnGoingDelivery: data.skipOnGoingDelivery,
      };
      if (data.selectedLocker) {
        context['locker_choice'] = 'locker_external_id_' + data.selectedLocker?.externalId;
      } else if (data.addressId) {
        // Must be `addressId`: the backend route reads context.addressId and nothing reads
        // address_id. newAddress is sent too - it gates the branch that looks at the id.
        context['addressId'] = data.addressId;
        context['newAddress'] = data.newAddress !== '' ? data.newAddress : this.formData.address;
      } else {
        context['newAddress'] = data.newAddress !== '' ? data.newAddress : this.formData.address;

        if (data.newAddressObject) {
          context['newAddressObject'] = data.newAddressObject;
          if (data.newAddressLat && data.newAddressLng) {
            context['newAddressObject']['latLng'] = {
              lat: data.newAddressLat,
              lng: data.newAddressLng,
            };
          }
          context['newAddressObject']['coordinatesSource'] = data.pinPlacedByUser
            ? 'manual'
            : 'geocoding';
        }
      }
      await axios
        .post(`${process.env.VUE_APP_COURIER_API}/user/reschedule/${this.voucher}`, context)
        .then(resp => {
          if (resp.data.shouldDownloadApp) {
            this.formData.SLMAppLink = true;
          }
          this.errorMessage = 'ok';
        })
        .catch(err => (this.errorMessage = err.response?.data?.error_description));
    },
  },
};
</script>

<style lang="scss" scoped>
$white: #fff;
$orange: #f68b24;
$orange8: rgb(246 139 36 / 80%);
$black: #363636;
$warning: #f44336;

.review-main {
  background-size: cover !important;
}

.cargo-pickup-form {
  flex-grow: 1;
}

@mixin flex-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

@media screen and (max-width: 733px) {
  .review-main {
    padding: 15px 0 224px;
    //margin-left: 55px;
  }
  form input {
    font-size: 14px;
  }
}

@media screen and (min-width: 733px) and (max-width: 961px) {
  .review-main {
    padding: 50px 0 433px;

    .container {
      margin: 0 59px;
    }
  }
}

@media screen and (max-width: 961px) {
  .review-main {
    justify-content: center;
    width: 100%;

    .container {
      width: 100%;
    }
  }
}

@media screen and (min-width: 961px) and (max-width: 1500px) {
  .container {
    margin-left: 64px !important;
  }
  .review-main {
    padding: 100px 0 256px;
  }
}

@media screen and (min-width: 1500px) {
  .container {
    margin-left: 64px !important;
  }
  .review-main {
    padding: 100px 0 256px;
  }
}
</style>
